import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";

const useSweetAlert = () => {
    const swalWrapper = useSwalWrapper();

    return ({
                title = "Are you sure?",
                text = "You won't be able to revert this!",
                icon = "warning",
                showCancelButton = true,
                confirmButtonText = "Yes, delete it!",
                cancelButtonText = "No, cancel!",
                reverseButtons = true
            }) => swalWrapper.fire({title, text, icon, showCancelButton, confirmButtonText, cancelButtonText, reverseButtons});
};

export default useSweetAlert;